import native, { isMC } from '@/utils'
import { instance } from '@/utils/axios'

const { appInfo } = native

export default {
  getUserInfo() {
    if (!isMC() && (appInfo.key || appInfo.token)) {
      return instance.get('users')
    }
    return {}
  },
  getProblemSource() {
    return instance.get('groups')
  },
  getBannerList() {
    return instance.get('banner/all')
  },
  getSomeHotList(id) {
    return instance.get(`articles/hotspots?group_id=${id}`)
  },
  getServiceList(id) {
    return instance.get(`groups/${id}`)
  },
  getGroupList(data) {
    if (data.all) {
      return instance.get(`articles/hotspots/all?group_id=${data.id}`)
    }
    return instance.get(`groups/${data.id}/articles`)
  },
  getArticle(id) {
    if (appInfo.key || appInfo.token) {
      return instance.get(`articles/${id}`)
    }
    return instance.get(`articles/${id}/share`)
  },
  sendMessage(data) {
    return instance.post('feedbacks', data)
  },
  searchProblem(data) {
    const id = data.id ? `&group_id=${data.id}` : ''
    return instance.get(`articles/search?keyword=${data.keyword}${id}`)
  },
  setLike(url) {
    return instance.put(url)
  },
}



// WEBPACK FOOTER //
// ./src/views/help-center/service/index.js